const GIFT_VARIANT_ID = 54929509777749;
const FREE_GIFT_PROPERTY = "__Free_Gift_PS_";

let giftBeingAdded = false;

/**
 * Check whether the cart contains a qualifying product
 */
function cartHasEligibleProduct(cart) {
  if (!cart?.items) return false;

  return cart.items.some((item) => {
    const type = item.product_type?.toLowerCase();
    return type === "loafer" || type === "boots";
  });
}

/**
 * Check whether the free gift is already in the cart
 */
function cartHasGift(cart) {
  if (!cart?.items) return false;

  return cart.items.some(
    (item) => Number(item.variant_id) === GIFT_VARIANT_ID
  );
}

/**
 * Main free gift checker
 */
async function checkFreeGift(cart = null) {
  try {
    // If cart wasn't provided by SlideCart, get the latest cart
    if (!cart) {
      const response = await fetch("/cart.js", {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
        cache: "no-store",
      });

      if (!response.ok) {
        throw new Error(`Cart fetch failed: ${response.status}`);
      }

      cart = await response.json();
    }

    console.log("Free gift cart check:", cart);

    const hasEligibleProduct = cartHasEligibleProduct(cart);
    const hasGift = cartHasGift(cart);

    console.log("Eligible product:", hasEligibleProduct);
    console.log("Gift already exists:", hasGift);

    // Nothing to do
    if (!hasEligibleProduct) {
      return;
    }

    // Gift already exists
    if (hasGift) {
      return;
    }

    // Prevent duplicate requests
    if (giftBeingAdded) {
      return;
    }

    await addGift();

  } catch (error) {
    console.error("Free gift check error:", error);
  }
}


/**
 * Add free gift
 */
async function addGift() {
  if (giftBeingAdded) return;

  giftBeingAdded = true;

  try {
    console.log("Adding free gift...");

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: {
              [FREE_GIFT_PROPERTY]: "True",
            },
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error(`Gift add failed: ${response.status}`);
    }

    const data = await response.json();

    console.log("Gift added:", data);

    /**
     * SlideCart discount
     */
    if (typeof window.SLIDECART_APPLY_DISCOUNT === "function") {
      window.SLIDECART_APPLY_DISCOUNT("posa_free_gift");
    }

    /**
     * Tell SlideCart to refresh
     */
    if (typeof window.SLIDECART_UPDATE === "function") {
      window.SLIDECART_UPDATE(data);
    }

    /**
     * Dispatch a standard event so other theme scripts
     * can react to the gift being added.
     */
    document.dispatchEvent(
      new CustomEvent("freegift:added", {
        detail: data,
      })
    );

  } catch (error) {
    console.error("Add gift error:", error);

  } finally {
    giftBeingAdded = false;
  }
}


/**
 * SlideCart integration
 *
 * This keeps your existing SlideCart functionality.
 */
window.SLIDECART_UPDATED = function (cart) {
  console.log("SLIDECART_UPDATED");

  if (!cart?.items) return;

  checkFreeGift(cart);
};


/**
 * Check cart when this script loads.
 *
 * This is important for the situation where:
 *
 * Add to cart quickly
 *      ↓
 * User goes directly to /cart
 *      ↓
 * SlideCart callback was never triggered
 *
 * We independently inspect /cart.js.
 */
function initializeFreeGift() {
  console.log("Free gift script initialized");

  checkFreeGift();
}


/**
 * Listen for common Shopify/theme cart events
 */
document.addEventListener("cart:updated", function (event) {
  console.log("cart:updated detected");

  if (event.detail?.cart) {
    checkFreeGift(event.detail.cart);
  } else {
    checkFreeGift();
  }
});


document.addEventListener("cart:refresh", function () {
  console.log("cart:refresh detected");
  checkFreeGift();
});


document.addEventListener("ajaxProduct:added", function () {
  console.log("ajaxProduct:added detected");
  checkFreeGift();
});


/**
 * Some Shopify themes don't dispatch custom events.
 *
 * Intercept fetch() requests to /cart/add.js so we can
 * detect products added through AJAX.
 */
(function watchCartFetch() {
  const originalFetch = window.fetch;

  if (!originalFetch) return;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const request = args[0];

      const url =
        typeof request === "string"
          ? request
          : request?.url || "";

      if (
        url.includes("/cart/add.js") ||
        url.includes("/cart/add")
      ) {
        /**
         * Don't immediately call checkFreeGift here.
         *
         * The original request may still be processing internally,
         * so wait a moment and then fetch the real cart.
         */
        setTimeout(() => {
          checkFreeGift();
        }, 100);
      }

    } catch (error) {
      console.warn("Cart fetch watcher error:", error);
    }

    return response;
  };
})();


/**
 * Start immediately if possible.
 *
 * We intentionally don't wait for the whole page to load.
 */
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeFreeGift);
} else {
  initializeFreeGift();
}


/**
 * Extra safety check for the cart page.
 *
 * If the user reaches /cart very quickly, this gives the script
 * another opportunity to inspect the final cart.
 */
if (window.location.pathname === "/cart") {
  setTimeout(() => {
    checkFreeGift();
  }, 500);

  setTimeout(() => {
    checkFreeGift();
  }, 1500);
}